import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { domain } from "../variables/domain";
import { map } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class NewProjectServices {
  constructor(private http: HttpClient) { }
  ProjectListServices(skip, take) {
    return this.http
      .get(
        domain.newProjectURL + "GetProjectList?skip=" + skip + "&take=" + take
      )
      .pipe(map((res: any) => res));
  }
  ProjectDetails(id) {
    return this.http
      .get(domain.newProjectURL + "GetProjectDetails?ProjectId=" + id)
      .pipe(map((res: any) => res));
  }
  GetProjectProperties(ProjectId) {
    return this.http
      .get(
        domain.GetProjectProperties +
        "?ProjectId=" +
        ProjectId +
        "&skip=0&take=10000"
      )
      .pipe(map((res: any) => res));
  }
  sendIntrest(ProjectId) {
    return this.http
      .post(
        domain.sendIntrest + "ProjectId=" + ProjectId + "&IsIntrested=1",
        {}
      )
      .pipe(map((res: any) => res));
  }

  getProjectImages(Id) {
    return this.http.get(domain.getNewProjectImages + Id, {}).pipe(map((res: any) => res));
  }
  getMyProject(userId, skip, take) {
    return this.http
      .get(domain.getMyProjects + "builderId=" + userId + "&IsBuilderProject=" + false + "&skip=" + skip + "&take=" + take)
      .pipe(map((res: any) => res));
  }
  getMyProjectLeades(skip, take, UserTypeId) {
    return this.http
      .get(
        domain.getMyLeades +
        "UserTypeId=" +
        UserTypeId +
        "&skip=" +
        skip +
        "&take=" +
        take
      )
      .pipe(map((res: any) => res));
  }

  SaveProjectProperty(details) {
    return this.http
      .post(domain.SaveProjectProperty, details)
      .pipe(map((res: any) => res));
  }
  DownloadBrochureDocument(details) {
    return this.http
      .post(domain.DownloadBrochureDocument, details)
      .pipe(map((res: any) => res));
  }
  SaveProjectImage(projectId, formData) {
    return this.http
      .post(domain.SaveProjectImage+projectId, formData)
      .pipe(map((res: any) => res));
  }
  UploadBrochure(formData) {
    return this.http
      .post(domain.UploadBrochure, formData)
      .pipe(map((res: any) => res));
  }
  UploadFloorPlan(formData) {
    return this.http
      .post(domain.UploadFloorPlan, formData)
      .pipe(map((res: any) => res));
  }
  UpdateProjectProperty(details) {
    return this.http
      .post(domain.UpdateProjectProperty, details)
      .pipe(map((res: any) => res));
  }
  RemoveProject(details) {
    return this.http
      .post(domain.RemoveProject + details, {})
      .pipe(map((res: any) => res));
  }
  DeleteProjectProperty(details) {
    return this.http
      .post(domain.DeleteProjectProperty + details, {})
      .pipe(map((res: any) => res));
  }
  DeleteProjectImage(imageId) {
    return this.http
      .post(domain.DeleteProjectImage + imageId, {})
      .pipe(map((res: any) => res));
  }
  SaveProject(postData) {
    return this.http.post(domain.saveProjectURL, postData).pipe(map((res) => res));
  }
  UpdateProject(postData) {
    return this.http.post(domain.UpdateProject, postData).pipe(map((res) => res));
  }
}
